var map = {
	"./de-de/txt_result.png": "8948",
	"./en-gb/txt_result.png": "394c",
	"./en-us/txt_result.png": "34b1",
	"./es-es/txt_result.png": "17bf",
	"./es-mx/txt_result.png": "21e0",
	"./fr-ca/txt_result.png": "fdb9",
	"./fr-fr/txt_result.png": "74b0",
	"./it-it/txt_result.png": "ee6b",
	"./ja-jp/txt_result.png": "40cf",
	"./pt-br/txt_result.png": "ba66",
	"./zh-tw/txt_result.png": "e24e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb92";